import { Flex, Space } from 'antd'
import { createStyles } from 'antd-style'

import { getFirstScrolledParent } from '@eastcoal/common/utils/dom'

import { WpsBackgroundColorIcon } from '@eastcoal/icon/WpsBackgroundColorIcon'

import { useFontBackgroundColor } from '../../hooks/useFontBackgroundColor'
import { SHORTCUTS } from '../../plugins/ShortcutsPlugin/shortcuts'
import { ColorCursor } from '../../ui/ColorCursor'
import { DropdownButton } from '../../ui/DropdownButton'
import { FontBackgroundColorPicker } from '../../ui/FontBackgroundColorPicker'
import { MenuButton } from '../../ui/MenuButton'

const useStyles = createStyles(({ token }) => ({
  container: {
    borderRadius: token.borderRadiusSM,
    [`&:hover`]: {
      backgroundColor: token.colorBgTextHover
    }
  }
}))

export const FontBackgroundColorButton = () => {
  const {
    fontBackgroundColor,
    setFontBackgroundColor,
    toggleFontBackgroundColor
  } = useFontBackgroundColor()

  const { styles } = useStyles()

  return (
    <Space.Compact className={styles.container}>
      <MenuButton
        tooltip={
          <Flex vertical align='center'>
            <span>突出显示</span>
            <span>{SHORTCUTS.FONT_BACKGROUND_COLOR}</span>
          </Flex>
        }
        onClick={toggleFontBackgroundColor}
      >
        <WpsBackgroundColorIcon />
        <ColorCursor color={fontBackgroundColor} />
      </MenuButton>
      <FontBackgroundColorPicker
        arrow={false}
        getPopupContainer={triggerNode => getFirstScrolledParent(triggerNode)}
        placement='bottomRight'
        value={fontBackgroundColor}
        onChange={setFontBackgroundColor}
      >
        <DropdownButton compact />
      </FontBackgroundColorPicker>
    </Space.Compact>
  )
}
